import * as util from '../apiUtils';
import * as common from '../apiCommon';
import * as DocType from '../../constants/constant_doc_types';

export function fetchOrderManagement(app, params) {
  const { id } = params;
  const docType = DocType.ORDER_MANAGEMENT;
  return common.getDoc(app, { id, docType });
}

export function deleteOrderManagement(app, data) {
  return common.deleteDoc(app, {
    id: data.id,
    docType: DocType.ORDER_MANAGEMENT,
  });
}

export function saveOrderManagement(app, dataToSave) {
  const { user = {}, data } = dataToSave;

  const orderManagement = {
    active: util.toBoolean(data.active),
    doc_type: DocType.ORDER_MANAGEMENT,
    name: util.toStringText(data.name),
    reference_id: util.toStringText(data.reference_id),
    available_from: data.available_from
      ? util.toStringDate(data.available_from)
      : null,
    available_to: data.available_to
      ? util.toStringDate(data.available_to)
      : null,
    order_method: util.toStringText(data.order_method),
    max_splits: util.toDecimal(data.max_splits),
    max_retries: util.toDecimal(data.max_retries),
    retry_time: util.toInteger(data.retry_time),
    enable_part_fulfillment: util.toBoolean(data.enable_part_fulfillment),
    ignore_hold: util.toBoolean(data.ignore_hold),
    currency_id: data.currency_id,
    subsidiary_id: data.subsidiary_id,
    order_group_id: data.order_group_id,
    default_location_id: data.default_location_id,
  };
  return common.saveDoc(app, {
    source: data,
    doc: orderManagement,
    user,
  });
}
